const LAZY_IMPORT_RETRY_STORAGE_KEY = "ibada:lazy-import-retry"

const RECOVERABLE_LAZY_IMPORT_ERROR_MARKERS = [
  "Failed to fetch dynamically imported module",
  "Importing a module script failed",
  "ChunkLoadError",
] as const

function getLazyImportErrorMessage(error: unknown) {
  if (error instanceof Error) {
    return error.message
  }

  return String(error ?? "")
}

function getLazyImportRetryKey() {
  if (typeof window === "undefined") {
    return null
  }

  return `${LAZY_IMPORT_RETRY_STORAGE_KEY}:${window.location.pathname}${window.location.search}`
}

export function isRecoverableLazyImportError(error: unknown) {
  const message = getLazyImportErrorMessage(error)

  return RECOVERABLE_LAZY_IMPORT_ERROR_MARKERS.some((marker) => message.includes(marker))
}

export function clearLazyImportRecovery() {
  if (typeof window === "undefined") {
    return
  }

  const retryKey = getLazyImportRetryKey()

  if (!retryKey) {
    return
  }

  window.sessionStorage.removeItem(retryKey)
}

export function attemptLazyImportRecovery(error: unknown) {
  if (typeof window === "undefined" || !isRecoverableLazyImportError(error)) {
    return false
  }

  const retryKey = getLazyImportRetryKey()

  if (!retryKey) {
    return false
  }

  const hasRetried = window.sessionStorage.getItem(retryKey) === "1"

  if (hasRetried) {
    window.sessionStorage.removeItem(retryKey)
    return false
  }

  window.sessionStorage.setItem(retryKey, "1")
  window.location.reload()
  return true
}
